module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG0976489c30c29fd58718c9ba77bbc863.0976489c.png";